import React from "react";
import { LinkPropsModel } from "./Link.model";
import NextLink from "next/link";
import { cn } from "@/lib/utils";

export function Link(props: LinkPropsModel) {
  const { as, className, disabled, children, ...linkProps } = props;

  const classnames = cn(
    // Base link styles using new design tokens
    "underline hover:text-core-blue visited:text-monochrome-darkGrey active:text-monochrome-darkGrey focus:text-monochrome-darkGrey",
    // Size variants using new Tailwind typography classes
    as === "lg" && "text-link-lg",
    as === "re" && "text-link-regular",
    as === "sm" && "text-link-sm",
    as === "xs" && "text-link-xs",
    disabled && "pointer-events-none",
    className,
  );

  return (
    <NextLink
      className={classnames}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      scroll={props.onClick ? false : true}
      {...linkProps}
    >
      {children}
    </NextLink>
  );
}
